import type { Side } from '@tank-battle/shared';

export const SIDE_COLORS: Record<Side, string> = {
  A: '#4caf50',
  B: '#ef5350',
};

export const TERRAIN_COLORS: Record<string, string> = {
  plain: '#2a3441',
  forest: '#1e3d2f',
  road: '#3a3a3a',
  water: '#1a3a5c',
  rubble: '#4a4035',
};

export const FOG_HIDDEN = '#0a0e12';
